import SuiBox from '@upheal/design-system/components/legacy/Sui/SuiBox';
import LogoFull from '@upheal/design-system/images/logo-full.svg?react';
import { SxProps } from '@mui/material';
import SuiTypography from '@upheal/design-system/components/legacy/Sui/SuiTypography';

type Props = {
    colorTheme: 'light' | 'dark';
    sx?: SxProps;
};

const LogoBox = (props: Props) => {
    const { colorTheme, sx } = props;
    return (
        <SuiBox
            height={56}
            sx={{
                position: 'relative',
                color: (theme) =>
                    colorTheme === 'dark' ? theme.palette.grey[100] : 'dark',
                ...sx,
            }}
        >
            <LogoFull viewBox="0 0 97 48" width="115" height="56" />
            {import.meta.env.VITE_REACT_APP_UPHEAL_API_URL ===
                'https://dev.api.upheal.io/api' && (
                <SuiTypography
                    variant="h5"
                    fontWeight="bold"
                    color="action"
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                    }}
                >
                    DEV
                </SuiTypography>
            )}
        </SuiBox>
    );
};

export default LogoBox;
